import { toast } from 'sonner'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useActiveTeams, useAddAllToTeam } from '../hooks'

type Props = {
  candidates: wowaudit.GuildCandidate[]
}

const AddAllToTeamButton = ({ candidates }: Props) => {
  const teams = useActiveTeams()
  const { mutate, isPending } = useAddAllToTeam()
  const unassignedCount = candidates.filter(
    (candidate) => candidate.teamIds.length === 0,
  ).length

  if (teams.length === 0) return null

  const addAll = (team: wowaudit.TeamReference) =>
    mutate(team.id, {
      onSuccess: () =>
        toast.success(
          `Added ${unassignedCount} ${
            unassignedCount === 1 ? 'candidate' : 'candidates'
          } to Team ${team.name}`,
        ),
    })

  const disabled = unassignedCount === 0 || isPending

  if (teams.length === 1) {
    return (
      <Button
        size='sm'
        variant='secondary'
        disabled={disabled}
        loading={isPending}
        onClick={() => addAll(teams[0])}
      >
        Add all to team
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button size='sm' variant='secondary' loading={isPending}>
          Add all to team
          <ChevronDown className='h-4 w-4' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        {teams.map((team) => (
          <DropdownMenuItem key={team.id} onSelect={() => addAll(team)}>
            Team {team.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default AddAllToTeamButton
